import React from "react";
import { authenticatedGetFetch } from "../../../utils/AuthenticatedFetch";
import { Trans } from "react-i18next";
import { Callout, Card, HTMLTable, Spinner, Tag } from "@blueprintjs/core";

import KeyData from "../../Structure/KeyData";

export default class ALPRPerformances extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      performances: {},
      deviceData: [],
    };
  }

  componentDidMount() {
    if (this.props.urlsearchparams !== undefined)
      this.setState({ loading: true }, () => {
        authenticatedGetFetch(
          "/activity/alpr/performances?" + this.props.urlsearchparams,
          (response) => {
            this.setState(
              {
                performances: response,
              },
              () => {
                authenticatedGetFetch(
                  "/activity/alpr/performances/devices?" +
                    this.props.urlsearchparams,
                  (response) => {
                    this.setState({
                      deviceData: response,
                      loading: false,
                    });
                  }
                );
              }
            );
          }
        );
      });
  }

  render() {
    if (this.props.urlsearchparams !== undefined) {
      const devicearray = [];
      for (const device of this.state.deviceData) {
        let tag = null;
        if (device?.perf >= 90)
          tag = <Tag intent="success">{device?.perf?.toFixed(2)} %</Tag>;
        else if (device?.perf >= 70)
          tag = <Tag intent="warning">{device?.perf?.toFixed(2)} %</Tag>;
        else tag = <Tag intent="danger">{device?.perf?.toFixed(2)} %</Tag>;

        devicearray.push(
          <tr key={"perf" + device.device}>
            <td>{device.park}</td>
            <td>{device.device}</td>
            <td>{device.movements}</td>
            <td>{device.plateRead}</td>
            <td>
              <div>{tag}</div>
            </td>
          </tr>
        );
      }

      return (
        <Callout icon="widget-button" title={<Trans>ALPR performances</Trans>}>
          {this.state.loading ? (
            <Spinner />
          ) : (
            <div className="flexbox-center">
              {this.state.performances?.entries === 0 &&
              this.state.performances?.exits === 0 ? (
                <Callout intent="primary">
                  <Trans>no plate read in the given period</Trans>
                </Callout>
              ) : devicearray.length > 0 ? (
                <>
                  <div>
                    {this.state.performances?.entries !== null && (
                      <KeyData
                        label={<Trans>Taux de lecture en entrée</Trans>}
                        data={this.state.performances?.perfEntry}
                        unit="%"
                        details={
                          "(" +
                          this.state.performances?.goodPlatesEntry +
                          "/" +
                          this.state.performances?.entries +
                          ")"
                        }
                      />
                    )}
                    {this.state.performances?.exits !== null && (
                      <KeyData
                        label={<Trans>Taux de lecture en sortie</Trans>}
                        data={this.state.performances?.perfExit}
                        unit="%"
                        details={
                          "(" +
                          this.state.performances?.goodPlatesExit +
                          "/" +
                          this.state.performances?.exits +
                          ")"
                        }
                      />
                    )}
                  </div>
                  <Card style={{ overflowY: "scroll", height: "30em" }}>
                    <HTMLTable striped={true} compact={true}>
                      <thead>
                        <tr>
                          <th>
                            <Trans>park</Trans>
                          </th>
                          <th>
                            <Trans>device</Trans>
                          </th>
                          <th>
                            <Trans>movements</Trans>
                          </th>
                          <th>
                            <Trans>plates read</Trans>
                          </th>
                          <th>
                            <Trans>performance</Trans>
                          </th>
                        </tr>
                      </thead>
                      <tbody>{devicearray}</tbody>
                    </HTMLTable>
                  </Card>
                </>
              ) : (
                <Callout intent="primary"><Trans>no data for the period</Trans></Callout>
              )}
            </div>
          )}
        </Callout>
      );
    } else return null;
  }
}
